var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { CommodityCode } from "./CommodityCode";
export class CommodityCodes {
  constructor(_data) {
    /**
     */
    __publicField(this, "Codes");
    /**
     */
    __publicField(this, "ValidityYear");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof CommodityCodes
     */
    __publicField(this, "$type", "V1.ComplianceMasterData.CommodityCodes");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      if (_data["Codes"] && _data["Codes"].constructor === Array) {
        this.Codes = [];
        for (let item of _data["Codes"]) {
          const codes_ = new CommodityCode();
          this.Codes.push(codes_.init(item));
        }
      }
      this.ValidityYear = _data["ValidityYear"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    if (this.Codes && this.Codes.constructor === Array) {
      _data["Codes"] = [];
      for (let item of this.Codes) {
        _data["Codes"].push(item.toJSON());
      }
    }
    _data["ValidityYear"] = this.ValidityYear;
    return _data;
  }
}
